import React from 'react';
import ReactDom from 'react-dom';

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {deepBind} from 'base-contentmodel';

import BaseComponent from 'base-component';
import BaseContentModel from 'base-contentmodel';

import {ButtonComponent, ProgressButtonComponent} from './component';

export class ButtonContentModel extends BaseContentModel {

    static get _slots() {
        return {
            label: "",
            tooltip: "",
            action: "",
            disabled: false,
            css: "",
            tabindex: 0,
        };
    }

    static get _defaults() {
        return {
            label: "Button",
            tooltip: "This is a tooltip",
            action: "submit",
            disabled: false,
            css: "",
            tabindex: 0,
        };
    }

    Component = ButtonComponent;

    @observable
    /* @slot */ label = "";

    @observable
    /* @slot */ tooltip = "";

    @observable
    /* @slot */ action = "";

    @observable
    /* @slot */ disabled = false;

    @observable
    /* @slot */ css = "";

    @observable
    /* @slot */ tabindex = 0;

    @observable @deepBind _options = {
        get actions() {
            return ["submit", "none"];
        }
    }
    
    @observable value = 0;
    isReadOnly = true;

    get variable() {
        if(this.action == "commit-1") {
            return "G:FI_RES_RunExplorationR1P1:G";
        }
        else if(this.action == "commit-2") {
            return "G:FI_RES_RunExplorationR1P2:G";
        }
        else if(this.action == "commit-3") {
            return "G:FI_RES_RunExplorationR2P1:G";
        }
        else if(this.action == "commit-4") {
            return "G:FI_RES_RunExplorationR2P2:G";
        }
        return null;
    }
}

export class ProgressButtonContentModel extends ButtonContentModel {
    
    static get _slots() {
        return Object.assign({}, ButtonContentModel._slots, {
        });
    }

    static get _defaults() {
        return Object.assign({}, ButtonContentModel._defaults, {
        });
    }
    
    Component = ButtonComponent;
}



export default ButtonContentModel;



// WEBPACK FOOTER //
// ./app_modules/form-control-activity/buttons/contentmodel.js